/**
 * HUB-B.3 — Accès visible et permanent à l'Historique des ventes depuis le Centre Activité.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { History, ArrowRight } from 'lucide-react';
import { historiqueLinkFromFilters } from '../../utils/historique/ventesDisplay';

export default function ActiviteHistoriqueAccessBanner({ filters, variant = 'default' }) {
  const to = historiqueLinkFromFilters(filters);
  const isCompact = variant === 'compact';

  return (
    <div
      className={`rounded-xl border flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 ${
        isCompact ? 'p-3' : 'p-4'
      }`}
      style={{
        borderColor: 'var(--rm-border-subtle)',
        background: 'var(--rm-bg-panel)',
      }}
      data-testid="activite-historique-access-banner"
    >
      <div className="flex items-start gap-3 min-w-0">
        <div
          className="shrink-0 w-10 h-10 rounded-xl flex items-center justify-center border"
          style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-elevated)' }}
        >
          <History className="w-5 h-5 text-[var(--rm-gray-200)]" />
        </div>
        <div className="min-w-0">
          <p className="text-sm font-semibold text-[var(--rm-white)]">
            Historique des ventes
          </p>
          <p className="text-xs text-[var(--rm-gray-500)] mt-0.5">
            Référence métier complète — filtres et vue dédiée conservés sur /historique.
          </p>
        </div>
      </div>
      <Link
        to={to}
        className="btn-secondary px-4 py-2.5 min-h-[44px] text-sm inline-flex items-center justify-center gap-2 shrink-0 w-full sm:w-auto"
        data-testid="activite-historique-access-banner-link"
      >
        Ouvrir l&apos;Historique
        <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
}
